import makeLatestArtifactSelectorCreator from './makeLatestArtifactSelectorCreator';
export const getRequestStatesDefault = state => {
  return state.requestStates;
};
export default makeLatestArtifactSelectorCreator(getRequestStatesDefault);